import { render, staticRenderFns } from "./anlidetails.vue?vue&type=template&id=d2c3a1fe&scoped=true&"
import script from "./anlidetails.vue?vue&type=script&lang=js&"
export * from "./anlidetails.vue?vue&type=script&lang=js&"
import style0 from "./anlidetails.vue?vue&type=style&index=0&id=d2c3a1fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c3a1fe",
  null
  
)

export default component.exports